import { render } from "./AddWorkout.vue?vue&type=template&id=49a020f1&scoped=true"
import script from "./AddWorkout.vue?vue&type=script&lang=js"
export * from "./AddWorkout.vue?vue&type=script&lang=js"

import "./AddWorkout.vue?vue&type=style&index=0&id=49a020f1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a020f1"]])

export default __exports__